import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AbstractService } from './abstract.service';
import { LoginService } from './login.service';
import { HabilFranqueadoraUsuario } from '../models/habil-franqueadora-usuario';

@Injectable({
  providedIn: 'root'
})
export class HabilFranqueadoraUsuarioService extends AbstractService<HabilFranqueadoraUsuario> {

  titulo: string = 'Hábil Franqueadora Usuário';
  endpoint(): string {
    return "habil-franqueadora-usuario";
  }
  rotina(): string {
    return "HABIL_FRANQUEADORA_USUARIO";
  }
  colunas(): any[] {
    return [
      { header: "Código", field: "id" },
      { header: "Login", field: "login" },
      { header: "Nome", field: "nome" },
    ];
  }
  novo(selection?: any) {
    AbstractService.readonly = false;
    this.router.navigate(['adm/habil-franqueadora-usuarios/cadastro']);
  }
  abrir(obj: HabilFranqueadoraUsuario) {
    AbstractService.readonly = true;
    this.router.navigate(['adm/habil-franqueadora-usuarios/cadastro'], { queryParams: { id: obj.id } });
  }
  edit(obj: HabilFranqueadoraUsuario) {
    AbstractService.readonly = false;
    this.router.navigate(['adm/habil-franqueadora-usuarios/cadastro'], { queryParams: { id: obj.id } });
  }
  routeLista() {
    return '/adm/habil-franqueadora-usuarios';
  }

  constructor(
    http: HttpClient,
    private router: Router,
    loginService: LoginService
  ) {
    super(http, loginService);
  }
}
